import { render, staticRenderFns } from "./corrosionProtection.vue?vue&type=template&id=138c388a&"
import script from "./corrosionProtection.vue?vue&type=script&lang=js&"
export * from "./corrosionProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports